import React, { useState, useEffect } from "react";
import "./stylesCotizadorProgrammaticDuracion.scss";

export const CotizadorProgrammaticDuracion = ({ onDuracionChange, defaultDuracion, duracion, resetCounter }) => {
  const [selectedDuration, setSelectedDuration] = useState(defaultDuracion || null);

  // Sincronizar con la prop duracion y resetear cuando cambie resetCounter
  useEffect(() => {
    if (resetCounter) {
      // Solo reseteamos si resetCounter cambia
      setSelectedDuration(duracion || null);
    } else if (duracion !== undefined) {
      // Solo actualizamos si duracion está definido
      setSelectedDuration(duracion);
    }
  }, [duracion, resetCounter]);

  // Ensure the parent is notified of the initial duration
  useEffect(() => {
    if (defaultDuracion) {
      setSelectedDuration(defaultDuracion); // Aseguramos que selectedDuration se sincronice con defaultDuracion
      onDuracionChange(defaultDuracion);
    }
  }, [defaultDuracion, onDuracionChange]);

  const handleDurationChange = (e) => {
    const duration = parseInt(e.target.value);
    setSelectedDuration(duration);
    onDuracionChange(duration);
  };

  return (
    <div className="duracion">
      <p className="tituloduracion">DURACIÓN</p>
      <hr />
      <p className="subtitulo">SPOT PUBLICITARIO</p>
      <hr />
      {[...Array(10)].map((_, index) => {
        const duration = index + 6;
        return (
          <div key={index}>
            <input
              checked={selectedDuration === duration}
              id={`duration-${duration}`}
              name="duration"
              onChange={handleDurationChange}
              style={{ width: "15px", height: "15px", marginRight: "10px" }}
              type="checkbox"
              value={duration}
            />
            <label htmlFor={`duration-${duration}`}>{`${duration} SEGUNDOS`}</label>
          </div>
        );
      })}
    </div>
  );
};
